// extracted by mini-css-extract-plugin
export default {"container":"UploadedDocument_container__CuI+4","upload__icon":"UploadedDocument_upload__icon__1BD+B"};